import { __assign, __rest } from "tslib";
import * as React from 'react';
import { Checkbox } from '../Checkbox/index.js';
import { RadioButton } from '../RadioButton/index.js';
/**
 * A multi-checkbox form element.
 */
export var Choices = function (_a) {
    var onChange = _a.onChange, error = _a.error, label = _a.label, _b = _a.value, value = _b === void 0 ? {} : _b, defaultValue = _a.defaultValue, children = _a.children, single = _a.single, props = __rest(_a, ["onChange", "error", "label", "value", "defaultValue", "children", "single"]);
    var _c = React.useState(defaultValue), choices = _c[0], setChoices = _c[1];
    var managed = React.useMemo(function () { return defaultValue !== undefined; }, []);
    var chosenChoices = managed ? choices : value;
    var Component = single ? RadioButton : Checkbox;
    return (React.createElement("div", { className: "form-group" },
        React.createElement("label", { className: "text-floating" }, label),
        React.createElement("div", __assign({}, props, { className: "choices" }), Object.keys(chosenChoices).map(function (s) { return (React.createElement(Component, { key: s, label: s, checked: chosenChoices[s], onChange: function (status) {
                var choices = __assign({}, chosenChoices);
                if (single) {
                    Object.keys(chosenChoices).forEach(function (choice) { return (choices[choice] = false); });
                }
                choices[s] = status;
                if (managed) {
                    setChoices(choices);
                }
                onChange === null || onChange === void 0 ? void 0 : onChange(choices);
            } })); })),
        children));
};
//# sourceMappingURL=index.js.map